import moment from 'moment'

export function hasResendExpired(sentAt: Date | null) {
  return !!sentAt && moment(sentAt).add(1, 'hour').isBefore(moment())
}
